import { ButtonPosition } from '@/common/manager/position/button-position';
export const config = {
    value: 'arraySubAreaCardMoveDown',
    position: [ButtonPosition.arraySubAreaCardOperate],
    action: (config) => {
        const { arrayBaseField, arrayBaseFieldIndex } = config || {};
        if (arrayBaseField) {
            if (arrayBaseField?.disabled === true ||
                arrayBaseField?.pattern !== 'editable') {
                return;
            }
            arrayBaseField?.moveDown(arrayBaseFieldIndex);
        }
    },
};
